/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import overviewAPI from 'src/api/overview';

export const getAvgSpeedToLead = createAsyncThunk('avgSpeed/get', async arg => {
  return overviewAPI.getAvgSpeedToLead(arg);
});

const Slice = createSlice({
  name: 'avgSpeed',
  initialState: {
    isTabExpended: true,
    message: '',
    data: [],
    arg: false,
  },
  reducers: {
    setTabExpend: (state, action) => {
      state.isTabExpended = action.payload;
    },
  },
  extraReducers: {
    [getAvgSpeedToLead.pending]: (state, action) => {
      state.status = 'loading';
      state.arg = action.meta.arg;
    },
    [getAvgSpeedToLead.fulfilled]: (state, action) => {
      const { status, message, data } = action.payload;
      state.status = status;
      state.message = message;
      state.data = data;
    },
    [getAvgSpeedToLead.rejected]: () => {},
  },
});

export const { setTabExpend, setTimeLine } = Slice.actions;
export default Slice.reducer;
